module.exports = __webpack_public_path__ + "img/DaySmartVet_reveal.559e605b.gif";